export function getForm(wfConfig, formId) {
    return wfConfig.formsById?.[formId];
}

//# sourceMappingURL=controller-props.js.map